import ReviewsCarousel from './ReviewsCarousel';
import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import {
  RedesignFooter,
  RedesignHeader,
  RedesignPage,
  SiteLink,
} from './RedesignShell';

const proofItems = [
  'создание и продвижение сайта с нуля',
  'стабильный поток заявок из поиска',
  'снижение стоимости лида',
  'развитие интернет-канала продаж',
];

const taskItems = [
  'создание сайта с SEO оптимизацией под ключевые запросы',
  'формирование структуры под семантическое ядро',
  'увеличение органического трафика',
  'вывод сайта в поисковую выдачу',
  'повышение конверсии страниц',
  'подготовка сайта к масштабному SEO продвижению',
];

const seoSiteTypes = [
  {
    href: 'https://fatalitystudio.ru/services/websites/landing/',
    title: 'Сайт с SEO-оптимизацией (лендинг)',
    text: 'Лендинг с SEO оптимизацией подходит для быстрых запусков и тестирования ниш. Он может привлекать трафик по низко- и среднечастотным запросам.',
    meta: 'landing · speed · meta',
  },
  {
    href: 'https://fatalitystudio.ru/services/websites/corporate/',
    title: 'Корпоративный сайт с SEO',
    text: 'Корпоративный сайт с SEO создается для компаний, которым важно продвижение услуг в поиске и формирование доверия к бренду.',
    meta: 'company · pages · trust',
  },
  {
    href: 'https://fatalitystudio.ru/services/websites/ecommerce/',
    title: 'Интернет-магазин с SEO',
    text: 'Интернет магазин с SEO оптимизируется под категории, фильтры и карточки товаров. Это позволяет получать продажи из органического трафика без постоянных вложений в рекламу.',
    meta: 'catalog · filters · sales',
  },
  {
    href: '/services/websites/service-business/',
    title: 'Многостраничный сайт-услуг с SEO',
    text: 'Такой сайт подходит для компаний с большим числом услуг. Структура строится на основе семантики и поисковых запросов.',
    meta: 'услуги · города · контент',
  },
  {
    href: null,
    title: 'Персонализированные сайты с SEO',
    text: 'Индивидуальные решения под сложные ниши: строительство, медицина, финансы, IT. Используется глубокий SEO-анализ конкурентов.',
    meta: 'custom · b2b · growth',
  },
];

const includedSteps = [
  [
    'Аналитика и проектирование',
    'Проводится анализ конкурентов, ниши и семантического ядра. Формируется структура сайта под SEO продвижение.',
  ],
  [
    'UX/UI дизайн сайта',
    'Разрабатывается дизайн, который повышает конверсию и улучшает поведенческие факторы.',
  ],
  [
    'Разработка и верстка',
    'Создается быстрый и адаптивный сайт с правильной HTML-структурой, заголовками и тегами.',
  ],
  [
    'SEO-оптимизация сайта',
    'Включает: создание гибридной структуры, базовую техническую SEO-оптимизацию, настройку мета-тегов, формирование заголовков H1–H3, внутреннюю перелинковку, оптимизацию страниц под запросы, закупку ссылок для продвижения в Гугле, перелинковку.',
  ],
  [
    'Тестирование и запуск',
    'Проверяется скорость, адаптивность, индексация и корректность работы сайта.',
  ],
];

const technologies = [
  [
    'Frontend',
    'Используются современные технологии HTML, CSS, JavaScript для скорости загрузки и удобства пользователей.',
  ],
  [
    'Backend',
    'Применяются решения на Laravel, Symfony и других фреймворках для надежной работы сайта.',
  ],
  [
    'CMS и платформы (Tilda, WordPress и др.)',
    'Используются популярные CMS: WordPress, Tilda, OpenCart для быстрого запуска и SEO-управления.',
  ],
  [
    'Интеграции и API',
    'Подключаются CRM, аналитика, сквозная аналитика и маркетинговые системы.',
  ],
];

const creationSteps = [
  [
    'Анализ и бриф',
    'Собирается информация о бизнесе, услугах/товарах, целевой аудитории и целях продвижения.',
  ],
  [
    'Проектирование структуры (прототип)',
    'Создается структура сайта на основе семантического ядра и ключевых запросов.',
  ],
  [
    'Дизайн сайта',
    'Разрабатывается уникальный дизайн с учетом UX и конверсии.',
  ],
  [
    'Разработка',
    'Происходит создание сайта с SEO и техническая реализация проекта.',
  ],
  [
    'Запуск и оптимизация',
    'Сайт запускается, проводится первичная индексация и SEO-настройка.',
  ],
];

const collaborationFormats = [
  [
    'Создание сайта с SEO под ключ',
    'Полный цикл: от идеи до запуска и SEO-настройки.',
  ],
  [
    'Выделенная команда',
    'Над проектом работает команда: дизайнер, разработчик, SEO-специалист, линкбилдер.',
  ],
  [
    'Почасовая работа',
    'Гибкий формат для доработок и поддержки.',
  ],
];

const deliverables = [
  [
    'Готовый сайт с SEO-структурой',
    'Сайт полностью готов к продвижению в Google и Яндекс.',
  ],
  [
    'Оптимизацию под рекламу и SEO',
    'Сайт работает и для SEO, и для контекстной рекламы.',
  ],
  [
    'Удобную систему управления',
    'Простое управление контентом без программистов.',
  ],
  [
    'Масштабируемую структуру',
    'Сайт легко расширяется под новые услуги и направления.',
  ],
];

const supportItems = [
  [
    'Техническая поддержка',
    'Обновления, исправления и стабильная работа сайта.',
  ],
  [
    'SLA и гарантии',
    'Фиксированные сроки и контроль качества.',
  ],
  [
    'Доработки',
    'Добавление новых страниц и функций.',
  ],
  [
    'SEO-продвижение сайта',
    'Дальнейшая работа по росту позиций и трафика, постоянные СЕО-работы: закупка ссылок, публикация и продвижение статей,оптимизация кейсов и другое.',
  ],
];

const priceFactors = [
  'количества страниц',
  'сложности структуры',
  'CMS или кастомной разработки',
  'уровня SEO-проработки',
];

const priceRows = [
  ['Базовый сайт с SEO', '10–14 дней', 'от 120 000 ₽'],
  ['Сайт с расширенной SEO-структурой', '2–3 недели', 'от 200 000 ₽'],
  ['Сайт с SEO и интеграциями', '3–5 недель', 'от 300 000 ₽'],
];

const relatedServices = [
  {
    href: '/services/websites/corporate/',
    title: 'Разработка корпоративных сайтов',
    meta: 'компания · услуги',
  },
  {
    href: '/services/websites/landing/',
    title: 'Разработка лендингов',
    meta: 'реклама · заявки',
  },
  {
    href: '/services/websites/ecommerce/',
    title: 'Разработка интернет-магазинов',
    meta: 'каталог · продажи',
  },
  {
    href: 'https://fatalitystudio.ru/services/seo/',
    title: 'SEO',
    meta: 'позиции · трафик',
  },
];

const caseMetrics = [
  ['3–7 раз', 'рост органического трафика в 3–7 раз'],
  ['top-10', 'выход в топ-10 Google по коммерческим запросам'],
  ['40–70%', 'снижение стоимости заявки на 40–70%'],
  ['лиды', 'увеличение количества лидов без роста бюджета на рекламу'],
];

const reviews = [
  {
    name: 'Даниил К.',
    role: 'владелец кулинарной студии',
    full: 'Даниил К., владелец кулинарной студии',
    text: 'Заказали разработку сайта под SEO и продвижение. Уже через 2 месяца сайт начал получать заявки из поиска. По ключевым коммерческим запросам вышли в топ-10 Яндекс. Трафик вырос почти в 5 раз.',
  },
  {
    name: 'Екатерина С.',
    role: 'маркетолог премиального ресторана в Москве',
    full: 'Екатерина С., маркетолог премиального ресторана в Москве',
    text: 'Делали создание сайта с продвижением с нуля. Структура сразу была собрана под SEO. Через 4 месяца получили стабильный поток клиентов из органики',
  },
  {
    name: 'Марат Ф.',
    role: 'владелец интернет-магазина детских игрушек',
    full: 'Марат Ф., владелец интернет-магазина детских игрушек',
    text: 'Интернет-магазин с SEO сделали правильно с самого начала. Уже в первый месяц пошли продажи из поиска. Сейчас больше 60% заказов из органического трафик',
  },
];

const faqItems = [
  [
    'Сколько стоит разработка сайта под SEO?',
    'Стоимость зависит от структуры сайта, количества страниц и уровня SEO-проработки. В среднем цена формируется индивидуально после анализа бизнеса и конкурентов.',
  ],
  [
    'Почему сайт с SEO не заменит рекламу?',
    'SEO и реклама работают вместе. SEO дает стабильный органический трафик, а реклама — быстрые заявки. В комплексе они дают максимальный результат.',
  ],
  [
    'Сроки создания сайта?',
    'Создание сайта с SEO занимает от 2 до 8 недель в зависимости от сложности проекта и количества страниц. Далее - поддержка, и продолжение проработки семантического ядра вплоть до супер-низкочастотных.',
  ],
  [
    'Что нужно для старта?',
    'Для старта достаточно описания бизнеса, услуг и целевой аудитории. Далее формируется семантическое ядро и структура сайта.',
  ],
  [
    'Подходит ли сайт для продвижения?',
    'Да, сайт изначально создается как SEO-friendly. Это значит, что он готов к продвижению сразу после запуска без доработок.',
  ],
];

function BulletList({ items }) {
  return (
    <ul className="source-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

function SectionHeader({ eyebrow, title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      <p className="sub">{description}</p>
    </div>
  );
}

function SeoWebsiteDevelopmentPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Разработка и продвижение сайта под SEO - заказать разработку под поисковые системы (сео)"
        description="Закажите профессиональную разработку сайта с продвижением (под SEO). Создание сайта под алгоритмы Яндекса и Гугла. Любые cms-системы, индивидуальная разработка, интеграции, продвижение (сео) со старта. Системный подход, множество кейсов и команда профессионалов. Рассчитайте стоимость в веб-студии fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{
            right: '-360px',
            top: '-340px',
            width: '980px',
            height: '980px',
            opacity: 0.1,
          }}
        />
        <div className="container service-hero-grid">
          <div>
            <div className="eyebrow cyan">— seo · структура · трафик</div>
            <h1>
              Разработка сайта под SEO и{' '}
              <span className="accent">продвижение</span>
            </h1>
            <p className="hero-sub">
              Разработка сайта под SEO и продвижение — это комплексная услуга,
              которая объединяет создание сайта, SEO-оптимизацию и подготовку к
              продвижению в поисковых системах. Такой подход позволяет получить
              сайт, который начинает привлекать трафик сразу после запуска и не
              требует полной переработки под SEO в дальнейшем.
            </p>
            <p className="service-hero-copy">
              Создание сайта под алгоритмы Яндекса и Гугла. Любые cms-системы,
              индивидуальная разработка, интеграции, продвижение (сео) со
              старта.
            </p>
            <div className="hero-ctas">
              <SiteLink href="#seo-website-lead" className="btn btn-primary">
                Получить расчет →
              </SiteLink>
              <SiteLink
                href="/portfolio/sokolniki-restaurant/"
                className="btn btn-ghost-dark"
              >
                кейс SEO-сайта
              </SiteLink>
            </div>
          </div>
          <div
            className="service-hero-panel"
            aria-label="Состав SEO-разработки сайта"
          >
            {[
              'семантика',
              'карта сайта',
              'ux/ui дизайн',
              'техническое seo',
              'аналитика',
            ].map((item, index) => (
              <div className="panel-line" key={item}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{item}</b>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— бизнес"
            title="Разработка сайта под SEO для бизнеса"
            description="Разработка сайта под SEO для бизнеса — это создание ресурса, который изначально учитывает требования поисковых систем Google и Яндекс."
          />
          <p className="service-hero-copy" style={{ color: '#141619' }}>
            В отличие от обычной разработки, здесь сразу закладывается
            структура под семантическое ядро, что позволяет быстрее выйти в топ
            по целевым запросам.
          </p>
          <p className="service-hero-copy" style={{ color: '#141619' }}>
            Такой подход используют компании, которым важно:
          </p>
          <div className="proof-strip">
            {proofItems.map((item, index) => (
              <div className="proof-item" key={item}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                {item}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— задачи"
            title="Какие задачи решает разработка сайта с SEO"
            description="Разработка сайтов с продвижением решает сразу несколько бизнес-задач:"
          />
          <div className="split-proof">
            <div>
              <p>
                Фактически сайт с SEO — это не просто дизайн и код, а
                инструмент продаж.
              </p>
              <SiteLink
                href="#seo-website-lead"
                className="btn btn-primary"
                style={{ marginTop: '32px' }}
              >
                Сайт с инструментом продаж - в Fatality
              </SiteLink>
            </div>
            <div className="check-grid">
              {taskItems.map((item) => (
                <div className="check-item" key={item}>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— форматы"
            title="Какие сайты мы разрабатываем под SEO"
            description="Сайт с SEO-оптимизацией, корпоративный сайт с SEO, интернет-магазин с SEO, многостраничный сайт-услуг с SEO или персонализированный сайт с SEO."
            dark
          />
          <div className="compact-card-grid">
            {seoSiteTypes.map((item, index) => {
              const card = <>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <div className="eyebrow cyan">{item.meta}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                <span className="link-flat">Узнать стоимость</span>
              </>;

              return item.href ? (
                <SiteLink href={item.href} className="compact-card interactive-card" key={item.title}>
                  {card}
                </SiteLink>
              ) : (
                <div className="compact-card" key={item.title}>{card}</div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— состав работ"
            title="Что входит в разработку сайта под SEO"
            description="Аналитика и проектирование, UX/UI дизайн сайта, разработка и верстка, SEO-оптимизация сайта, тестирование и запуск."
          />
          <div className="process-rail process-rail-five">
            {includedSteps.map(([title, text], index) => (
              <div className="process-step" key={title}>
                <div className="process-num">
                  {String(index + 1).padStart(2, '0')}
                </div>
                {title === 'SEO-оптимизация сайта' ? (
                  <SiteLink href="https://fatalitystudio.ru/services/seo/"><h3>{title}</h3></SiteLink>
                ) : <h3>{title}</h3>}
                <p>{text}</p>
              </div>
            ))}
          </div>
          <SiteLink
            href="#seo-website-lead"
            className="btn btn-primary section-action"
          >
            Начать проект
          </SiteLink>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— технологии"
            title="Технологии разработки сайтов под SEO"
            description="Frontend, Backend, CMS и платформы, Интеграции и API."
            dark
          />
          <div className="tech-tiles">
            {technologies.map(([title, text], index) => (
              <div className="tech-tile" key={title}>
                <div className="why-n">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— процесс"
            title="Как проходит создание сайта с SEO-продвижением"
            description="Анализ и бриф, проектирование структуры, дизайн сайта, разработка, запуск и оптимизация."
          />
          <div className="process-rail process-rail-five">
            {creationSteps.map(([title, text], index) => (
              <div className="process-step" key={title}>
                <div className="process-num">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— подход"
            title="Подход к разработке сайтов с SEO"
            description="SEO-first подход, прозрачные этапы и фокус на органическом трафике."
          />
          <div className="compact-card-grid">
            {[
              [
                'SEO-first подход',
                'Сайт создается сразу под продвижение в поисковых системах.',
              ],
              [
                'Прозрачные этапы',
                'Все этапы разработки фиксируются и контролируются.',
              ],
              [
                'Фокус на органическом трафике',
                'Главная цель — рост трафика из поиска и снижение зависимости от рекламы.',
              ],
            ].map(([title, text], index) => (
              <div className="compact-card" key={title}>
                <div className="compact-num">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— сотрудничество"
            title="Форматы сотрудничества"
            description="Создание сайта с SEO под ключ, выделенная команда или почасовая работа."
            dark
          />
          <div className="compact-card-grid">
            {collaborationFormats.map(([title, text], index) => (
              <div className="compact-card interactive-card" key={title}>
                <div className="compact-num">
                  {String(index + 1).padStart(2, '0')}
                </div>
                {index === 0 ? (
                  <SiteLink href="https://fatalitystudio.ru/services/seo/full-cycle/"><h3>{title}</h3></SiteLink>
                ) : <h3>{title}</h3>}
                <p>{text}</p>
                <SiteLink href="#seo-website-lead" className="link-flat">
                  Выбрать этот формат
                </SiteLink>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— итог"
            title="Что вы получаете в итоге"
            description="Готовый сайт с SEO-структурой, оптимизацию под рекламу и SEO, удобную систему управления и масштабируемую структуру."
          />
          <div className="compact-card-grid">
            {deliverables.map(([title, text], index) => (
              <div className="compact-card" key={title}>
                <div className="compact-num">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
          <SiteLink
            href="#seo-website-lead"
            className="btn btn-primary section-action"
          >
            Заказать разработку сайта под SEO
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— поддержка"
            title="Поддержка и развитие сайта"
            description="Техническая поддержка, SLA и гарантии, доработки, SEO-продвижение сайта."
          />
          <div className="compact-card-grid">
            {supportItems.map(([title, text], index) => (
              <div className="compact-card" key={title}>
                <div className="compact-num">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— стоимость"
            title="Стоимость разработки сайта под SEO"
            description="Стоимость разработки сайта с продвижением зависит от задач проекта."
          />
          <div className="pricing-layout">
            <div className="price-list">
              <h3 className="pricing-subhead">От чего зависит цена</h3>
              <p className="service-hero-copy" style={{ color: '#141619' }}>
                Цена зависит от:
              </p>
              <BulletList items={priceFactors} />
              <h3 className="pricing-subhead">Примерные цены</h3>
              <p className="service-hero-copy" style={{ color: '#141619' }}>
                Разработка сайта с SEO может варьироваться от базовых решений до сложных проектов с глубокой структурой.
              </p>
              <div className="price-row price-row-three price-row-head">
                <span>Тип сайта</span>
                <small>Срок</small>
                <b>Стоимость</b>
              </div>
              {priceRows.map(([type, time, price]) => (
                <div className="price-row price-row-three" key={type}>
                  <span>{type}</span>
                  <small>{time}</small>
                  <b>{price}</b>
                </div>
              ))}
            </div>
            <div className="price-note">
              <h3>Как рассчитывается стоимость</h3>
              <p>
                Стоимость формируется после анализа ниши, конкурентов и семантики.
              </p>
              <h3>Получить расчет</h3>
              <p>
                Есть идея или проект? Оставьте заявку — рассчитаем стоимость и
                предложим решение.
              </p>
              <div className="manager-note">
                <span>F</span>
                <p>
                  Менеджер ответит в течение 1 часа и уточнит SEO-задачу
                  проекта.
                </p>
              </div>
              <SiteLink href="#seo-website-lead" className="btn btn-primary">
                Получить расчёт бесплатно
              </SiteLink>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— рядом"
            title="Похожие услуги"
            description="Разработка корпоративных сайтов, разработка лендингов, разработка интернет-магазинов, SEO."
          />
          <div className="related-grid">
            {relatedServices.map((item) => (
              <SiteLink
                href={item.href}
                className="related-card"
                key={item.title}
              >
                <h3>{item.title}</h3>
                <span>{item.meta}</span>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— кейсы"
            title="Кейсы разработки сайтов под SEO"
            description="Примеры с результатами. После внедрения SEO-структуры сайты выходили в топ поисковых систем по целевым запросам уже в первые месяцы."
            dark
          />
          <h3 className="pricing-subhead">Примеры с результатами</h3>
          <SiteLink
            href="/portfolio/sokolniki-restaurant/"
            className="case-teaser"
          >
            <div className="case-blur-media seo-blur">
              <div className="case-blur-tag">seo · structure · leads</div>
              <div className="case-blur-title">top-10 и x5 трафика</div>
            </div>
            <div className="case-teaser-body">
              <div className="eyebrow cyan">— сайт услуг под SEO</div>
              <h3>Сайт с SEO-структурой и ростом органики</h3>
              <p>
                После внедрения SEO-структуры сайты выходили в топ поисковых
                систем по целевым запросам уже в первые месяцы.
              </p>
              <span className="link-flat">открыть кейс</span>
            </div>
          </SiteLink>
          <div className="proof-strip" style={{ marginTop: '48px' }}>
            <div className="proof-item">
              <span>00</span>
              Примеры результатов:
            </div>
            {caseMetrics.map(([value, text]) => (
              <div className="proof-item" key={value}>
                <span>{value}</span>
                {text}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— отзывы"
            title="Отзывы клиентов: от идеи — к сайту и трафику"
            description="Даниил К., Екатерина С. и Марат Ф. о создании сайта с продвижением."
          />
          <ReviewsCarousel className="reviews-grid reviews-grid-three">
            {reviews.map((review) => (
              <figure className="review-card" aria-label={review.full} key={review.name}>
                <blockquote>{review.text}</blockquote>
                <figcaption>
                  <b>{review.name}</b>
                  <span>{review.role}</span>
                </figcaption>
              </figure>
            ))}
          </ReviewsCarousel>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <div className="eyebrow">— faq</div>
              <h2 className="standalone-h2">Ответы на частые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map(([question, answer], index) => {
                const isOpen = openFaq === index;
                return (
                  <div
                    className={`faq-item${isOpen ? ' open' : ''}`}
                    key={question}
                  >
                    <button
                      className="faq-q"
                      type="button"
                      onClick={() => setOpenFaq(isOpen ? -1 : index)}
                    >
                      <h3 className="faq-question-heading">{question}</h3>
                      <span className="faq-toggle">+</span>
                    </button>
                    <div className="faq-a">
                      <div className="faq-a-inner">{answer}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="seo-website-lead">
        <div
          className="glow"
          style={{
            left: '-300px',
            top: '-200px',
            width: '700px',
            height: '700px',
            opacity: 0.1,
          }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— заявка</div>
              <h2 className="lead-heading">Заказать разработку сайта под SEO</h2>
              <p className="lead-text">
                Разработка сайта под SEO и продвижение позволяет получить готовый инструмент продаж, который начинает
                работать уже после запуска. Оставьте заявку, чтобы создать сайт с SEO-структурой, оптимизацией и
                готовностью к продвижению в поисковых системах.
              </p>
              <a
                href="tel:+79256530454"
                className="link-flat"
                style={{ marginTop: '28px' }}
              >
                Предпочитаете позвонить? +7 (925) 653-04-54
              </a>
            </div>
            <LeadForm
              formId="seo-website-lead-form"
              idPrefix="seo-website"
              contactLabel="Телефон или E-mail"
              contactType="text"
              contactPlaceholder="+7 или почта"
              showCompany={false}
              typeOptions={[
                'SEO-лендинг',
                'Корпоративный сайт с SEO',
                'Интернет-магазин с SEO',
                'Доработка сайта',
              ]}
              submitLabel="Получить расчёт бесплатно"
              taskPlaceholder="Ниша, услуги, регион, текущий сайт и цель по трафику"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default SeoWebsiteDevelopmentPage;
